import { render } from "./overduevisits.vue?vue&type=template&id=6de8ff8e"
import script from "./overduevisits.vue?vue&type=script&lang=js"
export * from "./overduevisits.vue?vue&type=script&lang=js"

import "./overduevisits.vue?vue&type=style&index=0&id=6de8ff8e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__